var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFAC05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75486 6.45605H11.2917C14.1131 6.45605 16.2033 7.78647 16.9937 9.94194H18.436C18.8728 9.94194 19.192 10.2275 19.192 10.6475C19.192 11.0675 18.8896 11.3867 18.436 11.3867L17.3129 11.3867C17.3306 11.5812 17.3397 11.7801 17.3397 11.9833C17.3397 12.1978 17.3293 12.4078 17.3089 12.6131H18.436C18.8728 12.6131 19.192 12.9155 19.192 13.3187C19.192 13.7387 18.8896 14.0579 18.436 14.0579H16.9744C16.1624 16.1982 14.0584 17.5441 11.2917 17.5441H8.75486C8.21726 17.5441 7.83086 17.1577 7.83086 16.6201V14.0579H6.25161C5.79801 14.0579 5.49561 13.7387 5.49561 13.3187C5.49561 12.9155 5.81481 12.6131 6.25161 12.6131H7.83081L7.83086 11.3867L6.25161 11.3867C5.79801 11.3867 5.49561 11.0675 5.49561 10.6475C5.49561 10.2275 5.81481 9.94194 6.25161 9.94194H7.83081L7.83086 7.38005C7.83086 6.84245 8.21726 6.45605 8.75486 6.45605ZM9.61166 11.3867V12.6131H15.4506C15.4778 12.4102 15.4917 12.2001 15.4917 11.9833C15.4917 11.7778 15.4797 11.5788 15.4563 11.3867L9.61166 11.3867ZM14.997 9.94194H9.61166V8.06885H11.2749C13.02 8.06885 14.3295 8.75681 14.997 9.94194ZM14.97 14.0579H9.61166V15.9481H11.2749C12.9725 15.9481 14.2865 15.2408 14.97 14.0579Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDai);
export default __webpack_public_path__ + "static/media/dai.ee9fd2996851481a1c4e010fe0cb9beb.svg";
export { ForwardRef as ReactComponent };